import React from 'react';
import { Col, Form, Row, Button } from 'react-bootstrap';
import Input from '../../../Elements/Input';
import '../assets/InvolvedParty.scss';
import { IInvolvedParty } from '../../../../common/sharedTypes';

interface IInvolvedPartyStateProps {
  involvedParties: IInvolvedParty[];
  errorLength?: string;
  errorFirstName?: string;
  errorLastName?: string;
  errorBusinessName?: string;
}

interface IInvolvedPartyActions {
  onChange: (event: any) => void;
  onIpBlur: (event: any) => void;
}

export interface IInvolvedPartyProps
  extends IInvolvedPartyStateProps,
  IInvolvedPartyActions { }

function checkboxChange() {
  if (checkboxValue == null) {
    checkboxValue = true;
    console.log('checkboxValue: ', checkboxValue);
    return;
  }
  if (checkboxValue == false) {
    checkboxValue = true;
    console.log('checkboxValue: ', checkboxValue);
    return;
  }
  if (checkboxValue == true) {
    checkboxValue = false;
    console.log('checkboxValue: ', checkboxValue);
    return;
  }
}

let checkboxValue;
export const InvolvedParty: React.FC<IInvolvedPartyProps> = ({
  involvedParties,
  errorLength,
  errorFirstName,
  errorLastName,
  errorBusinessName,
  onChange,
  onIpBlur,
}) => (
  <div className='involvedParty'>
    {involvedParties.map((involvedParty, i) => {
      let businessOwned =
        involvedParty.businessOwned != undefined
          ? involvedParty.businessOwned
          : !!involvedParty.businessName;
      return (
        <Form.Row className='align-items-center' key={involvedParty.id}>
          <Form.Group as={Col} className='involvedPartiesGroup'>
            <Button
              className='btn btn-danger'
              variant='primary'
              name='deleteInvolvedParty'
              onClick={onChange}
              value={involvedParty.id}
              tabIndex={10 + i * 10 + 1}
            >
              -
            </Button>
            <Form.Label>
              Involved Party:
              <br />
            </Form.Label>
          </Form.Group>
          <Form.Check
            inline
            type='checkbox'
            label='Business Owned'
            name={`${involvedParty.id}|businessOwned`}
            value='yes'
            checked={businessOwned}
            id={`${involvedParty.id}|businessOwned`}
            onChange={onChange}
            tabIndex={10 + i * 10 + 2}
          />

          <Form.Group
            as={Col}
            className='involvedPartiesGroup'
            hidden={businessOwned}
          >
            <Input
              title=''
              name={`${involvedParty.id}|lastName`}
              label='Last Name'
              type='text'
              value={involvedParty.lastName}
              onChange={onChange}
              onBlur={onIpBlur}
              placeholder={'Last Name'}
              tabIndex={10 + i * 10 + 3}
            />
            {errorLastName !== '' && (
              <Form.Label className='error'>{errorLastName}</Form.Label>
            )}
          </Form.Group>
          <Form.Group
            as={Col}
            className='involvedPartiesGroup'
            hidden={businessOwned}
          >
            <Input
              title=''
              name={`${involvedParty.id}|firstName`}
              label='First Name'
              type='text'
              value={involvedParty.firstName}
              onChange={onChange}
              onBlur={onIpBlur}
              placeholder={'First Name'}
              tabIndex={10 + i * 10 + 4}
            />
            {errorFirstName !== '' && (
              <Form.Label className='error'>{errorFirstName}</Form.Label>
            )}
          </Form.Group>
          <Form.Group
            as={Col}
            hidden={!businessOwned}
            className='involvedPartiesGroup'
          >
            <Input
              as={Col}
              title=''
              name={`${involvedParty.id}|businessName`}
              label='Business Name'
              type='text'
              value={involvedParty.businessName}
              onChange={onChange}
              onBlur={onIpBlur}
              placeholder={'Business Name'}
              tabIndex={10 + i * 10 + 5}
            />
            {errorBusinessName !== '' && (
              <Form.Label className='error'>{errorBusinessName}</Form.Label>
            )}
          </Form.Group>
          <Form.Group as={Col} hidden={!businessOwned}>
            {' '}
          </Form.Group>
        </Form.Row>
      );
    })}

    <Form.Group>
      {errorLength !== '' && (
        <Form.Label className='error'>{errorLength}</Form.Label>
      )}
    </Form.Group>
    <Row>
      <Form.Group as={Col} className='addButton'>
        <Form.Group className='sm-3'>
          <Button
            className='btn btn-success'
            variant='primary'
            name='addInvolvedParty'
            onClick={onChange}
            tabIndex={9999}
          >
            +
          </Button>
          <Form.Label>Add new involved party</Form.Label>
        </Form.Group>
      </Form.Group>
    </Row>
  </div>
);
